import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

export const TerminosYCondicionesAvanzaSolido = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          TÉRMINOS Y CONDICIONES CHATBOT ASOLIBOT (AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R.)
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Chatbot ASOLIBOT de AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. es un bot (robot) que usa el servicio de
          mensajería denominado WhatsApp propiedad de WhatsApp LLC como una plataforma de interacción con usuarios que
          deseen recibir información sobre los productos, servicios y ofertas de AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario declara haber leído, entendido y aceptado los presentes términos y con lo cual se adhiere a ellas
          plenamente y sin reservas. El uso de este servicio está sujeto al estricto cumplimiento de los términos
          recogidos en las presentes condiciones y, en su caso, a las condiciones particulares que resulten de su
          aplicación.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario declara y garantiza estar apto y tener capacidad legal para aceptar las presentes condiciones y
          usar este servicio conforme a ellas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Acerca del Servicio. El servicio permite a los usuarios poder acceder a información sobre la Sociedad
          Financiera, sus productos o servicios, e información propia del usuario (si es cliente de la Sociedad
          Financiera), y solicitud de aplicación a ciertos productos y servicios, de acuerdo con lo siguiente:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Uso y Registro del Servicio. El usuario podrá hacer uso del servicio y recibir información general de la
          Sociedad Financiera, sin ningún registro previo. El cliente acepta que el Chatbot envíe mensajes de respuesta
          a solicitudes y también acepta que el Chatbot inicié una conversación.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para el uso del servicio, el usuario deberá iniciar una conversación a través de mensajería instantánea
          mediante una cuenta de WhatsApp propia, enviando cualquier texto al número de teléfono +529612408934, o bien
          escaneando el Código QR que estará disponible en la publicidad de AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R., o
          bien mediante el link de acceso{" "}
          <a href="https://api.whatsapp.com/send?phone=5219612408934&text=hola" target="_blank">
            https://api.whatsapp.com/send?phone=5219612408934&text=hola
          </a>{" "}
          aceptar los términos y condiciones del servicio de mensajería, y seguir las instrucciones.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario declara conocer y aceptar que el servicio estará habilitado de modo indefinido; sin embargo, acepta
          que AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. podrá deshabilitarlo en cualquier momento. Asimismo, acepta que si
          AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. identifica un mal uso o uso indebido de los recursos habilitados a
          través del servicio, podrá dejar sin efecto su acceso al servicio y/o adoptar cualquier otra medida que a su
          sola discrecionalidad estime conveniente.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El usuario es responsable de la información y/o datos que ingrese en el servicio al momento de darse de alta,
          sin embargo, AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. es Responsable del Tratamiento y Uso de los Datos
          Personales que el Usuario le proporciones a través del Chatbot, en términos de su Aviso de Privacidad visible
          en la página web{" "}
          <a href="https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf" target="_blank">
            https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf
          </a>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Servicio</strong>. Toda operación de consulta realizada por el Usuario a través del Chatbot se
          presumirá hecha por el Usuario bajo su total responsabilidad. De manera general, todo Usuario por el simple
          hecho de acceder al Servicio se obliga a:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Hacer uso del Servicio únicamente para fines lícitos y/o en forma diligente y correcta. Cumplir con todas y
          cada una de las demás obligaciones establecidas en las Condiciones, así como las demás que puedan inferirse de
          un uso correcto, de buena fe y/o racional del Servicio. <br />
          No vulnerar derechos de terceros. El incumplimiento de cualquiera de estas obligaciones y/o de otras
          contempladas en el presente documento, dará lugar a las responsabilidades administrativas, civiles y/o penales
          correspondientes.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R., sus funcionarios, directores o empleados, no serán responsables en
          forma alguna de las consecuencias que, por el incumplimiento de cualquiera de las obligaciones o prohibiciones
          mencionadas en el presente numeral o de las presentes Condiciones, se puedan generar.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Reconocimiento y liberación de responsabilidad.</strong> El Usuario asume totalmente la
          responsabilidad por permitir el acceso a terceros a su sesión de WhatsApp propiedad de WhatsApp LLC, liberando
          a AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. de toda responsabilidad por el mal uso. El Usuario declara conocer y
          aceptar que, por la propia naturaleza de los servicios que se brindan a través de Internet, éstos se
          encuentran sujetos a la disponibilidad, restricciones de uso y limitaciones de Internet, así como otros
          factores externos, por lo que libera a AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R. de toda responsabilidad por los
          perjuicios que pudiesen derivarse de dicho suceso.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Datos personales.</strong> La información proporcionada por el Usuario será utilizada para su registro
          en el Servicio y/o para contactarlo de manera directa, de ser el caso. Así, el Usuario autoriza expresamente
          el Tratamiento y Uso de sus Datos Personales en términos de su Aviso de Privacidad visible en la página web
          <a href="https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf" target="_blank">
            https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf.
          </a>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Acerca de WhatsApp.</strong> El usuario declara conocer y acepta que le serán aplicables los términos
          de uso y políticas de privacidad de WhatsApp, según sean variados por WhatsApp LLC, según los cuales WhatsApp
          dará tratamiento a sus Datos Personales.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Disposiciones.</strong> El cliente declara que el servicio de WhatsApp propiedad de WhatsApp LLC puede
          sufrir interrupciones, retrasos o imperfecciones, lo que puede provocar que el Chatbot no responda hasta que
          WhatsApp normalice su servicio.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Cliente acepta que el Chatbot tendrá acceso a su localización sólo cuando él acepte enviarla. El ChatBot
          controlará el tiempo de inactividad en la comunicación y solicitará al Usuario que vuelva a introducir sus
          datos de usuario para consultas de información.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <strong>Modificaciones.</strong> AVANZA SÓLIDO S.A. DE C.V. SOFOM E.N.R., podrá introducir cambios a las
          presentes Condiciones. El uso del servicio por parte del Usuario después de dichos cambios constituirá la
          aceptación tácita a los mismos, por lo que declara conocer que la versión que se encontrará disponible en la
          página web en términos de su Aviso de Privacidad visible en la página web
          <a href="https://www.avanzasolido.com.mx/Terminosycondiciones_Chatbotaso.pdf" target="_blank">
            https://www.avanzasolido.com.mx/Terminosycondiciones_Chatbotaso.pdf
          </a>
          , será la vigente al momento de su consulta.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Acuerdo. Las presentes Condiciones de acceso al Chatbot junto con los términos y condiciones de WhatsApp,
          constituye la totalidad de los términos y condiciones acordados entre el Usuario y AVANZA SÓLIDO S.A. DE C.V.
          SOFOM E.N.R. El Usuario asume y acepta que dará el buen uso al presente servicio.
          <br /> <br />
        </Typography>
      </Box>
    </>
  );
};
